import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export function DiscountDialog({ target, biz, onApply, onClose }) {
  const [type, setType] = useState("pct");
  const [value, setValue] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (target) {
      setType(target.current?.type || "pct");
      setValue(target.current?.value || "");
      setError("");
    }
  }, [target]);

  const apply = (disc) => {
    const err = onApply(disc);
    if (err) setError(err);
    else onClose();
  };

  const submit = (e) => {
    e.preventDefault();
    if (!value.trim()) return apply(null);
    if (!/^\d*\.?\d*$/.test(value.trim())) return setError("Enter a valid number");
    apply({ type, value: value.trim() });
  };

  return (
    <Dialog open={!!target} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-sm" data-testid="discount-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-xl">{target?.title}</DialogTitle>
          <DialogDescription>Percentage or a fixed {biz.currency} amount.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div className="grid grid-cols-2 gap-1 rounded-xl bg-slate-100 p-1" role="radiogroup">
            {[["pct", "Percent %"], ["fixed", `Fixed ${biz.currency}`]].map(([k, l]) => (
              <button
                type="button"
                key={k}
                onClick={() => { setType(k); setError(""); }}
                data-testid={`discount-type-${k}`}
                className={`h-11 rounded-lg text-sm font-semibold transition-colors ${type === k ? "bg-white text-slate-900 shadow-sm" : "text-slate-500"}`}
              >
                {l}
              </button>
            ))}
          </div>
          <input
            autoFocus
            inputMode="decimal"
            value={value}
            onChange={(e) => { setValue(e.target.value); setError(""); }}
            placeholder={type === "pct" ? "10" : biz.decimals === 3 ? "0.500" : biz.decimals === 0 ? "50" : "50.00"}
            data-testid="discount-value-input"
            className="money h-14 w-full rounded-xl border border-slate-300 px-4 text-2xl font-bold outline-none focus:border-slate-900 focus:ring-4 focus:ring-amber-200"
          />
          {error && <div className="rounded-lg bg-rose-50 px-3 py-2 text-sm font-medium text-rose-700" data-testid="discount-error">{error}</div>}
          <div className="flex gap-2">
            {target?.current && (
              <button type="button" onClick={() => apply(null)} data-testid="discount-remove-button" className="h-12 flex-1 rounded-xl border border-slate-300 font-semibold text-slate-700 hover:bg-slate-50">
                Remove
              </button>
            )}
            <button type="submit" data-testid="discount-apply-button" className="h-12 flex-[2] rounded-xl bg-slate-900 font-semibold text-white hover:bg-slate-800">
              Apply discount
            </button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
